import React from 'react';

interface PageTransitionProps {
  children: React.ReactNode;
  className?: string;
}

export const PageTransition: React.FC<PageTransitionProps> = ({ children, className = '' }) => {
  return (
    <div className={`animate-fade-in ${className}`}>
      {children}
    </div>
  );
};

interface StaggerItemProps {
  children: React.ReactNode;
  className?: string;
  index?: number;
}

export const StaggerItem: React.FC<StaggerItemProps> = ({ children, className = '', index = 0 }) => {
  return (
    <div 
      className={`stagger-item ${className}`}
      style={{ animationDelay: `${index * 0.1}s` }}
    >
      {children}
    </div>
  );
};

interface FadeInProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}

export const FadeIn: React.FC<FadeInProps> = ({ children, className = '', delay = 0 }) => {
  return (
    <div className={`animate-fade-in ${className}`} style={{ animationDelay: `${delay}s` }}>
      {children}
    </div>
  );
};

interface HoverScaleProps {
  children: React.ReactNode;
  className?: string;
}

export const HoverScale: React.FC<HoverScaleProps> = ({ children, className = '' }) => {
  return (
    <div className={`transition-transform duration-200 hover:scale-[1.02] active:scale-[0.98] ${className}`}>
      {children}
    </div>
  );
};

interface FloatingProps {
  children: React.ReactNode;
  className?: string;
}

export const Floating: React.FC<FloatingProps> = ({ children, className = '' }) => {
  return (
    <div className={`animate-float ${className}`}>
      {children}
    </div>
  );
};
